import React from "react";
import { Route, Link } from "react-router-dom";
import styled from "styled-components";
import logo from "./ui/assets/minibeak_logo.png";
import MenuNode, { MenuItem } from "./DocumentationMenuNode";
import { docSections } from "./docSections";

function filterMenuItems(nodes: Array<MenuItem>, filter: string) {
  return nodes
    .map((node) => {
      const { name, children } = node;

      const filteredChildren =
        children && filterMenuItems(children || [], filter);

      if (filteredChildren && filteredChildren.length) {
        return {
          ...node,
          children: filteredChildren,
        };
      } else {
        // if (children && children.length) return null; // disables matching branch nodes
        if (typeof name !== "string") return node;
        return name.toLowerCase().includes(filter.toLowerCase()) ? node : null;
      }
    })
    .filter((node) => node);
}

const DocsMenu: React.FC = () => {
  const searchValue = ""; // No search for now

  const visibleMenuItems = filterMenuItems(docSections, searchValue);

  return (
    <Route path="/:pageSlug?">
      <StyledDiv>
        <Link to="/">
          <h1>
            <img className="logo" alt="logo" src={logo} />
            minibeak
          </h1>
        </Link>

        {visibleMenuItems.map((node) => (
          <MenuNode key={node.name} node={node} />
        ))}
      </StyledDiv>
    </Route>
  );
};

const StyledDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 20rem;
  height: 100vh;
  box-sizing: border-box;

  padding: 2rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  a {
    text-decoration: none;
  }

  .logo {
    width: 50px;
    display: inline-block;
  }

  h1 {
    margin-top: 0;
    color: #d9531e;
  }
`;

export default DocsMenu;
